import { VerdantColorSchemes } from "../types";
/**
 * Guard to validate verdant variants
 *
 * @param {string} colorScheme color
 * @returns {boolean} checks if is a Verdant color scheme
 */
export function isVerdantColorScheme(colorScheme) {
    return (typeof colorScheme === "string" &&
        colorScheme in VerdantColorSchemes &&
        // base usually don't follow the sames rules as the other color schemes and is the default
        colorScheme !== VerdantColorSchemes.base);
}
